module.exports = "./img/81f347b209fdb1406340d279cc1ce5ee.jpg";